import { getSlugsWithoutStep } from '@finn/ua-auth';
import { useParams } from 'next/navigation';

export const useCheckoutParams = () => {
  const params = useParams();

  return getSlugsWithoutStep(params?.slug);
};
